<template>
    <div v-if="showReferralBanner">
        <g-card class="g-mt-7" @click="handleClick">
            <g-media-object vertical-align="center">
                <template #left>
                    <g-typography tag="h2" font-weight="semibold" class="title">
                        Refer GRIN to a brand. <br />
                        Earn up to 10% commission.
                    </g-typography>

                    <g-typography tag="p"> Join the Creator Referral program </g-typography>
                </template>

                <template #right>
                    <g-typography tag="h5" class="join">
                        Join Now
                        <g-icon name="chevron-right" type="light" size="small" />
                    </g-typography>
                </template>
            </g-media-object>
        </g-card>
    </div>
</template>

<script>
    import { computed } from 'vue-demi';
    import { CREATOR_REFERRAL_LINK } from '../../../../../app-v2/constants/links';
    import { useFeatureFlagsStore } from '../../../../../stores/';
    import useWhiteLabeling from '../../../../composables/use-white-labeling';

    export default {
        name: 'ReferralBanner',

        setup() {
            const featureFlags = useFeatureFlagsStore().data;

            const showReferralBanner = computed(() => {
                return (
                    (featureFlags['live-site-creator-referral-banner-ad'] || false) &&
                    !useWhiteLabeling().isWhiteLabeled()
                );
            });

            const handleClick = () => {
                location.href = CREATOR_REFERRAL_LINK;
            };

            return {
                showReferralBanner,
                handleClick
            };
        }
    };
</script>

<style lang="scss" scoped>
    .g-card {
        background-color: #e1e2e5;
        cursor: pointer;

        .title {
            line-height: 1.4rem;
        }

        .join {
            min-width: 90px;
            text-align: right;
        }

        @media (max-width: $g-screen-size-xs) {
            .media-object-container {
                display: block;

                ::v-deep > div {
                    margin-left: 0;
                    margin-right: 0;
                }

                .join {
                    margin-top: $g-spacing-5;
                    text-align: left;
                }
            }
        }
    }
</style>
